import React from "react";
import { useSelector, useDispatch } from "react-redux";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Login from "./Login";
import { UiWhiteCard } from "../../_uiComponents/common/UiWhiteCard";
import { BillPaymentUnSuccessIcon } from "../../../styles/img/svg/BillPaymentUnSuccessIcon";

const AuthWrapper = (props) => {
  const {
    customErrors,
    userDetails,
    loader,
    auth,
    keyGeneration,
    isAdminPasswordResetRequired,
    loginOtpTimer,
    multiTabOpen,
  } = useSelector((state) => {
    return {
      customErrors: state.errorMessage?.customErrors,
      loginOtpTimer: state.auth?.loginOtpTimer,
      userDetails: state.auth?.userDetails,
      loader: state.loading,
      auth: state.auth,
      keyGeneration: state.keyGeneration,
      isAdminPasswordResetRequired: state.auth?.isAdminPasswordResetRequired,
      multiTabOpen: state.auth?.multiTabOpen,
    };
  });

  return (
    <div className={"dl-ui-wrapper dl-auth"}>
      {multiTabOpen ? (
        <Container maxWidth="md" className="df-pos-rel">
          <div className="df-user-profile df-transaction-confirmation">
            <UiWhiteCard>
              <div className="df-confirmation-card">
                <div className="df-confirmation-card__header">
                  <BillPaymentUnSuccessIcon />
                  <h4 className={"df-danger"}>Error!</h4>
                  <p>
                    This application supports the use of single tab within your
                    browser. Please close any open tabs before trying again.
                  </p>
                </div>
              </div>
            </UiWhiteCard>
          </div>
        </Container>
      ) : (
        <Container className={""} fluid={"true"}>
          <Row className={""}>
            <Col xs={"12"} lg={"6"} md={"6"}></Col>
            <Col xs={"12"} lg={"6"} md={"6"}>
              <Login {...props} />
            </Col>
          </Row>
        </Container>
      )}
    </div>
  );
};

export default AuthWrapper;
